// eslint-disable-next-line jira/filename-case
import { createHook } from '../index.tsx';
import { getProductUsageStartTimestamp } from './product-usage-start-timestamp.tsx';

export const useProductUsageStartTimestamp: () => string | undefined = createHook(
	getProductUsageStartTimestamp,
);
